module.exports = require("@swissquote/crafty-commons/packages/semver.js");